export class DownloadHistory {
  dateTime: Date;
  userName: string;
  fileName: string;
  ipAddress: string;
}
